import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject, input, output } from '@angular/core';
import {Chat} from "@cdk/models";
import {LoginService} from "../../../../main/auth/login/login.service";

import { ChatImagemComponent } from '../chat-imagem/chat-imagem.component';
import { SortByDatePipe } from '../../../../../@cdk/pipes/sort-by-date.pipe';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
    selector: 'chat-list',
    templateUrl: './chat-list.component.html',
    styleUrls: ['./chat-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [ChatImagemComponent, MatProgressSpinner, SortByDatePipe]
})
export class ChatListComponent implements OnInit
{
    private _loginService = inject(LoginService);

    readonly chatList = input<Chat[]>([]);
    readonly chatOpen = input<Chat>(null);
    readonly loading = input<boolean>(true);

    readonly chatClickHandler = output<Chat>();



    /**
     * @param _loginService
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
    }

    chatClick(chat: Chat) : void
    {
        this.chatClickHandler.emit(chat);
    }
}
